import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface NetworkListCustomerHeaderProps
  extends HeaderContext<GatewayNetworkModel, GatewayNetworkModel['customer']> {}

export const NetworkListCustomerHeader =
  (): // props: NetworkListCustomerHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-gateway-network.customer');
  };
